import React, { Component } from "react";
import Scheduler, { SchedulerData, ViewTypes } from "react-big-scheduler";
import "./demo.css";
import axios from "axios";
import "react-big-scheduler/lib/css/style.css";
import { Link } from "react-router-dom";
import AssignStaff from "../AssignStaff";
import ShiftConfig from "../ShiftConfig";
import { currentCareSiteId } from "../../../redux-toolkit/reducer/switchSites";
import moment from "moment";
import cx from "../shift.module.css";
import md from "./newcss.module.css";
import { DragDropContext } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import { ShowInfoSwal, ShowSwal } from "../../../utils/alertSwal";
import { httpAdmin } from "../../../Apis/commonApis";
import { colorCodes } from "../../../constants/constants";
import { AiOutlineUsergroupAdd, AiOutlineCloseCircle } from "react-icons/ai";
import swal from "sweetalert";
import "moment/locale/en-gb";
import { AiFillPrinter } from "react-icons/ai";
import JsonDownload from "../../../components/DownloadExcel/DownloadExcel";
import {
  combineDateTime,
  convertTimeToUserTimeZone,
  convertToTimeZone,
  getCurrentTimeZone,
  getFullName,
  getWeekStartAndEndDates,
  handleDataPrint,
  isDateTimeGreaterThanCurrent,
  sortByDate,
  sortDataByKey,
} from "../../../utils/CommonFunctions";
import CareTeamReassignment from "../demo/CareTeamReassignment";
import ShiftCompletionPopup from "../demo/ShiftCompletionPopup";
import proxycompleteIcon from "./proxycomplete.svg";
import ShiftCreationForm from "./ShiftCreationDemo";
import AssignStaffNew from "./AssignStaffNew";
const chatUserImg = `${process.env.REACT_APP_REDIRECTION_URL_PLAN}/admin/images/chatUser.svg`;

class RotaScheduler extends Component {
  constructor(props) {
    super(props);

    const pageHeight = window.innerHeight - 350;

    // moment.locale('en-gb');
    //let schedulerData = new SchedulerData(new moment("2017-12-18").format(DATE_FORMAT), ViewTypes.Week);
    this.schedulerData = new SchedulerData(
      new Date(),
      ViewTypes.Week,
      false,
      false,
      {
        schedulerWidth: "88%",
        resourceTableWidth: 0,
        schedulerMaxHeight: pageHeight,
        besidesWidth: 0,
        defaultEventBgColor: "#808080",
        resourceName: "",
        movable: true,
        creatable: true,
        crossResourceMove: false,
        eventItemPopoverEnabled: true,
        calendarPopoverEnabled: true,
        dayResourceTableWidth: "0",
        weekResourceTableWidth: "0",
        monthResourceTableWidth: "0",
        eventItemHeight: 150,
        eventItemLineHeight: 150,
        selectedAreaColor: "#808080",
        recurringEventsEnabled: true,
        headerEnabled: true,
        displayWeekend: true,
        nonWorkingTimeHeadColor: "grey",
        nonWorkingTimeHeadBgColor: "white",
        nonWorkingTimeBodyBgColor: "white",
        groupOnlySlotColor: "#808080.",
        startResizable: true,
        customCellWidth: 80,
        dayCellWidth: "5%",
        endResizable: true,
        weekCellWidth: "14.26%",
        monthCellWidth: "13%",
        views: [
          {
            viewName: "Day",
            viewType: ViewTypes.Day,
            showAgenda: false,
            isEventPerspective: false,
          },
          {
            viewName: "Week",
            viewType: ViewTypes.Week,
            showAgenda: false,
            isEventPerspective: false,
          },
          {
            viewName: "Month",
            viewType: ViewTypes.Month,
            showAgenda: false,
            isEventPerspective: false,
          },
        ],
      }
    );

    this.schedulerData.localeMoment.locale("en-gb");
    this.schedulerData.setResources([{ id: 1, name: "" }]);

    this.state = {
      viewModel: this.schedulerData,
      shiftConfigData: null,
      showAssignStaffUI: false,
      showCreateShift: false,
      createShiftDate: "",
      assignStaffEventDetails: null,
      isDisplayed: false,
      EventsArr: [],
      groupArr: [],
      groupWithColorData: [],
      downloadData: [],
      SchedulerAccess: props.SchedulerAccess,
      loader: true,
      intervalId: "",
      siteTimeZone: this.props.siteTimeZone,
      openReassignment: false,
      allCareTeamData: [],
      shiftTaskData: {},
      tasks: [],
      openShiftCompletion: false,
    };
  }

  componentDidMount() {
    // const intervalId = setInterval(() => {
    //   this.getShiftsandtaskNew();
    // }, 60000);
    this.getShiftsandtaskNew();
    this.getClientGroupData();
    // this.setState(() => ({ intervalId: intervalId }));
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalId);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.text !== this.props.text) {
      const searchTxt = this.props?.text?.toLowerCase();
      const events =
        searchTxt !== ""
          ? this.state.EventsArr.filter(
              (eItem) =>
                eItem.title?.toLowerCase()?.includes(searchTxt) ||
                eItem.assignedCareTeam?.some((cItem) => {
                  const memberName = getFullName(cItem.careteam)?.toLowerCase();
                  return memberName?.includes(searchTxt);
                })
            )
          : this.state.EventsArr;
      this.schedulerData.setEvents(sortByDate(events, "start", ""));
      this.forceUpdate(); // Force a re-render of the component
    }
    if (prevProps.reloadData !== this.props.reloadData) {
      this.getShiftsandtaskNew("refresh");
    }
    if (prevProps.siteTimeZone !== this.props.siteTimeZone) {
      this.setState((prevState) => ({
        ...prevState,
        siteTimeZone: this.props.siteTimeZone,
      }));
      this.forceUpdate(); // Force a re-render of the component
    }
  }

  getCareTeaams = async () => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const start = this.state.viewModel.startDate;
    const end = this.state.viewModel.endDate;
    const res = await httpAdmin(
      `getCareteam?careHomeId=${currentCareSiteId}&adminId=${userData._id}&startDate=${start}&endDate=${end}`,
      "get",
      null,
      null
    );

    this.setState((prevState) => ({
      allCareTeamData: res.careteamListing,
    }));
  };

  getShiftsandtaskNew = async (actionType) => {
    const start = this.state.viewModel.startDate;
    const end = this.state.viewModel.endDate;
    const res = await httpAdmin(
      `getShiftConfig?careHomeId=${currentCareSiteId}&startDate=${start}&endDate=${end}`,
      "get",
      null,
      null
    );

    if (res.status) {
      const shiftData = res.shiftData;
      const events = [];
      const downloadArr = [];
      this.setState({ tasks: res?.tasks });
      shiftData?.forEach((item) => {
        events.push({
          item: item,
          id: item._id,
          shiftId: item._id,
          mainshiftId: item.mainshiftId,
          // start: new Date(item.shiftStartDatetime),
          // end: new Date(item.shiftEndDatetime),
          start: combineDateTime(
            item.Date,
            item?.startingTime,
            getCurrentTimeZone()
          ),
          end: combineDateTime(
            item.Date,
            item?.endingTime,
            getCurrentTimeZone()
          ),
          // shiftTime: `${convertTimeToUserTimeZone(item.startingTime, item.timeZone)} - ${convertTimeToUserTimeZone(item.endingTime, item.timeZone)}`,
          // shiftTime: `${convertToTimeZone(
          //   item.shiftStartDatetime
          // )} - ${convertToTimeZone(item.shiftEndDatetime)}`,
          shiftTime: `${item.startingTime} - ${item.endingTime}`,
          shiftBreak: item.shiftBreak,
          resourceId: 1,
          assignedCareTeam: item.shiftMappings,
          title: item?.shiftName,
          bgColor: "#898988",
          recurringShiftType: item.recurringShiftType,
          openShiftZone: item?.openShiftZone,
        });
        downloadArr.push({
          ["Client Name"]: "",
          ["Date"]: item.Date,
          ["Shift Start Time"]: item.startingTime,
          ["Shift End Time"]: item.endingTime,
        });
      });
      this.schedulerData.setResources([{ id: 1, name: "" }]);
      this.schedulerData.setEvents(sortByDate(events, "start", ""));

      if (actionType === "createOrEdit") {
        this.setState((prevState) => ({
          ...prevState,
          // EventsArr: events.sort(compareDates),
          EventsArr: events,
          shiftConfigData: res.data?.data,
          downloadData: downloadArr,
          showCreateShift: false,
          showAssignStaffUI: false,
          assignStaffEventDetails: null,
        }));
      } else {
        this.setState((prevState) => ({
          EventsArr: events,
          shiftConfigData: res.data?.data,
          downloadData: downloadArr,
        }));
      }
    }
  };

  getClientGroupData = async () => {
    const res = await httpAdmin(
      `getClient?careHomeId=${currentCareSiteId}&isGroup=${true}`,
      "get",
      null,
      null
    );
    if (res.status) {
      const allTempClients = res?.clientListing
        ?.filter((tcItem) => tcItem.clientType === "client")
        .map((cItem) => cItem._id);
      const filterClosedClients = res?.clientListing?.filter((cItem) => {
        const removeTempClients = cItem?.clientGroup?.filter(
          (cgItem) => !allTempClients.includes(cgItem._id)
        );
        const isClientGroupEmpty =
          cItem?.clientType === "group"
            ? removeTempClients?.some(
                (client) => client?.clientStatus === "active"
              )
            : true;
        return cItem.clientStatus === "active" && isClientGroupEmpty;
      });
      const groupData = filterClosedClients?.map((item, index) => {
        return {
          groupId: item._id,
          zone:
            item.clientType === "client"
              ? `${getFullName(item)} - Temp`
              : item.zone,
          groupName:
            item.clientType === "client"
              ? `${getFullName(item)} - Temp`
              : item.groupName,
          groupColor: item.colorCode ?? "grey",
        };
      });
      const groupWithColorData = res?.clientListing?.map((item, index) => {
        const grpClients = item.clientGroup
          ?.map((cgItem) => cgItem.first_Name)
          ?.join(", ");
        return {
          groupId: item._id,
          zone:
            item.clientType === "client"
              ? `${getFullName(item)} - Temp`
              : item.zone,
          groupName:
            item.clientType === "client"
              ? `${getFullName(item)} - Temp`
              : `${item.groupName}`,
          groupColor:
            item.clientType === "client" ? "grey" : item.colorCode ?? "red",
          status: item.clientStatus === "active",
        };
      });
      this.setState((prevState) => ({
        ...prevState,
        groupArr: sortDataByKey(groupData, "zone"),
        groupWithColorData: sortDataByKey(groupWithColorData, "zone"),
      }));
    }
  };

  deleteConfirm(mainshiftId, shiftId, deleteType) {
    const deleteMessage =
      deleteType === "recurring"
        ? "Are you sure you want to delete all recurring shifts?"
        : "Are you sure you want to delete this shift?";

    swal({
      title: "Are you sure?",
      text: deleteMessage,
      buttons: {
        cancel: "Cancel",
        confirm: {
          text: "Yes",
          value: true,
        },
      },
    }).then((result) => {
      if (result) {
        // For now, call the same deleteShift function regardless of deleteType
        this.deleteShift(mainshiftId, shiftId, deleteType);
      }
    });
  }

  async deleteShift(mainshiftId, shiftId, deleteType) {
    let data = {
      type: deleteType,
    };
    if (deleteType === "single") {
      data.shiftId = shiftId;
    } else {
      data.mainshiftId = mainshiftId;
    }
    const res = await httpAdmin("deleteshift", "post", data, null);
    ShowSwal(res.status, res.message);
    if (res.status) {
      this.getShiftsandtaskNew();
    }
  }

  closeopenReassignment = () => {
    // this.getShiftsandtaskNew("refresh");
    this.setState({ openReassignment: false });
  };

  handleEventClick = (schedulerData, event) => {
    // Prevent the default behavior
    console.log("Event clicked. Preventing default behavior.");
  };

  handleActionClick = (action) => {
    if (this.state.SchedulerAccess === "full") {
      if (action === "create") {
        this.handleCreateShiftClick();
      } else if (action === "assign") {
        this.setState((prevState) => ({
          showAssignStaffUI: !prevState.showAssignStaffUI,
        }));
      } else if (action === "reAssign") {
        this.handleShowReassignment();
      }
    } else {
      ShowInfoSwal("Your user Role does not have access to this section.");
    }
  };

  handleCreateShiftClick() {
    const subsriptionStatus = this.props?.subsriptionStatus;
    if (subsriptionStatus !== "paused" && subsriptionStatus !== "blocked") {
      this.setState((prevState) => ({
        showCreateShift: !prevState.showCreateShift,
      }));
      document.body?.classList?.add("modal-scroll");
    } else {
      ShowSwal(
        false,
        subsriptionStatus == "blocked"
          ? "This site is blocked. Kindly clear outstanding payments to activate it again."
          : "Kindly renew your subscription in order for this functionality to work."
      );
    }
  }

  render() {
    const {
      viewModel,
      groupArr,
      downloadData,
      openReassignment,
      allCareTeamData,
      EventsArr,
    } = this.state;
    return (
      <>
        <div className="col-md-2 ps-2">
          <AiFillPrinter
            className="me-3 ms-1 curser_point"
            onClick={() => handleDataPrint(downloadData)}
          />
          <a className="curser_point">
            <JsonDownload
              fileName="shifttasks-excel"
              downloadfile={downloadData}
            />
          </a>
        </div>
        <div
          className="float-end btns_head actionBtnResponsive"
          style={{ marginTop: "-34px" }}
        >
          <div className="dropdown multiDrop">
            <button
              className="btn btn-primary dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
            >
              Actions
            </button>
            <ul className="dropdown-menu">
              <li>
                <a
                  disabled={this.state.SchedulerAccess !== "full"}
                  style={{ cursor: "pointer" }}
                  className="dropdown-item"
                  onClick={() => this.handleActionClick("create")}
                >
                  Create Shifts
                </a>
              </li>
              {/* <li>
                <a
                  disabled={this.state.SchedulerAccess !== "full"}
                  style={{ cursor: "pointer" }}
                  className="dropdown-item"
                  onClick={() => this.handleActionClick("assign")}
                >
                  Assign Staff
                </a>
              </li> */}
              <li>
                <a
                  disabled={this.state.SchedulerAccess !== "full"}
                  style={{ cursor: "pointer" }}
                  className="dropdown-item"
                  onClick={() => this.handleActionClick("reAssign")}
                >
                  Reassign Staff
                </a>
              </li>
            </ul>
          </div>
        </div>

        {!this.state.showAssignStaffUI && !this.state.showCreateShift && (
          <div
            className={cx.rotaResource}
            style={{
              height: "calc(100vh - 240px)",
              overflowY: "auto",
              overflowX: "hidden",
              width: "100%",
              paddingLeft: "1px",
            }}
          >
            <Scheduler
              schedulerData={viewModel}
              prevClick={this.prevClick}
              nextClick={this.nextClick}
              onSelectDate={this.onSelectDate}
              onViewChange={this.onViewChange}
              eventItemClick={this.eventClicked}
              // updateEventStart={this.updateEventStart}
              // updateEventEnd={this.updateEventEnd}
              // events={EventsArr}
              // startAccessor="start"
              // endAccessor="end"
              newEvent={this.newEvent}
              onScrollLeft={this.onScrollLeft}
              onScrollRight={this.onScrollRight}
              toggleExpandFunc={this.toggleExpandFunc}
              eventItemPopoverTemplateResolver={
                this.eventItemPopoverTemplateResolver
              }
              eventItemTemplateResolver={this.eventItemTemplateResolver}
              slotItemTemplateResolver={this.slotItemTemplateResolver}
            />
          </div>
        )}
        {this.state.openShiftCompletion && (
          <ShiftCompletionPopup
            shiftTaskData={{
              allShiftData: this.state.shiftTaskData,
              taskList: this.state?.tasks,
            }}
            closeShiftCompletion={this?.closeShiftCompletion}
          />
        )}

        {/* Assign Staff POPup */}
        <div
          className="modal"
          style={{
            display: this.state.showAssignStaffUI ? "block" : "none",
            overflow: "hidden",
          }}
        >
          <div>
            <div className="bg_popup"></div>
            <div
              className={`${md.assignModalMain} modal-dialog modal-lg`}
              style={{ overflow: "hidden" }}
            >
              <div
                className={`${md.assignModalContent} modal-content`}
                style={{ overflowY: "auto", maxHeight: "85vh" }}
              >
                <div className={`${md.assignModalHeader} modal-header`}>
                  <h5 className="modal-title" id="exampleModalLabel">
                    Assign Staff
                  </h5>
                  <Link
                    className="btn-close"
                    onClick={() => {
                      this.setState((prevState) => ({
                        showAssignStaffUI: false,
                        assignStaffEventDetails: null,
                      }));
                    }}
                    to="#"
                  ></Link>
                </div>
                <div className="modal-body p-0" style={{ overflowY: "auto" }}>
                  {this.state.showAssignStaffUI && (
                    <AssignStaffNew
                      getShiftsandtaskNew={this.getShiftsandtaskNew}
                      prevShiftData={this.state.shiftConfigData}
                      assignStaffEvent={this.state.assignStaffEventDetails}
                      groupArr={groupArr}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {openReassignment && (
          <CareTeamReassignment
            allCareTeam={allCareTeamData}
            openReassignment={openReassignment}
            closeopenReassignment={this.closeopenReassignment}
            shedulerType={"facility"}
          />
        )}
        {/* // Shift Configuration */}
        <div
          className={`modal ${md.inputmainModal} ${
            this.state.isDisplayed ? "" : ""
          }`}
          id="showCreateShift"
          style={{
            display: `${this.state.showCreateShift ? "block" : "none"}`,
          }}
        >
          <div className="bg_popup"></div>
          <div
            className="modal-dialog modal-lg"
            style={{
              maxWidth: "900px",
              height: "85vh",
              margin: "auto",
              marginTop: "7.5vh",
            }}
          >
            <div
              className="modal-content"
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }}
            >
              <div className={`${md.modalHeader} modal-header`}>
                <h2
                  className="modal-title"
                  style={{
                    fontSize: "20px",
                    fontWeight: 600,
                    color: "#1f2937",
                  }}
                >
                  Create Shift
                  <span>
                    {this.state.siteTimeZone
                      ? ` (Timezone used for shift creation - ${this.state.siteTimeZone})`
                      : ""}
                  </span>
                </h2>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    this.setState((prevState) => ({
                      showCreateShift: false,
                      createShiftDate: "",
                    }));
                    document.body?.classList?.remove("modal-scroll");
                  }}
                ></button>
              </div>

              <div
                className="modal-body"
                style={{ padding: "24px", overflowY: "auto", flex: 1 }}
              >
                {" "}
                {this.state.showCreateShift && (
                  // <ShiftConfig
                  //   getShiftsandtaskNew={this.getShiftsandtaskNew}
                  //   prevShiftData={this.state.shiftConfigData}
                  //   shiftDate={this.state.createShiftDate}
                  // />
                  // <ShiftCreationFacility />
                  <ShiftCreationForm
                    groupArr={groupArr}
                    getShiftsandtaskNew={this.getShiftsandtaskNew}
                    prevShiftData={this.state.shiftConfigData}
                    shiftDate={this.state.createShiftDate}
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        <ul className="statusBox text-center">
          <li>
            <span style={{ background: "purple" }}></span>
            Open Shift
          </li>
          <li>
            <span style={{ background: "#2D9CDB" }}></span>
            All Clients
          </li>
          <li>
            <span style={{ background: "red" }}></span>
            Deleted Groups
          </li>
          {this.state.groupWithColorData
            ?.filter((cItem) => cItem.status)
            ?.map((item) => {
              return (
                <li key={item.id}>
                  <span style={{ background: item.groupColor }}></span>
                  {item.zone}
                </li>
              );
            })}
        </ul>
      </>
    );
  }
  handleShowReassignment = () => {
    this.getCareTeaams();
    this.setState({ openReassignment: true });
  };
  closeShiftCompletion = () => {
    this.setState({ openShiftCompletion: false });
  };

  eventItemPopoverTemplateResolver = (
    schedulerData,
    eventItem,
    title,
    start,
    end,
    statusColor
  ) => {
    const shiftStartDateTimeWithGrace =
      eventItem?.item?.shiftStartDatetimeWithGracePeriod;
    const isShiftDatepassed = isDateTimeGreaterThanCurrent(
      shiftStartDateTimeWithGrace ?? start.format(),
      new Date()
    );
    const isShowProxyBtn = isDateTimeGreaterThanCurrent(
      shiftStartDateTimeWithGrace ?? end.format(),
      new Date()
    );
    const formattedDate = moment
      .utc(start.format())
      .local()
      .format("YYYY-MM-DD");
    const actionClickHandler = (type, deleteType = "") => {
      if (this.state.SchedulerAccess === "full") {
        if (type === "delete") {
          this.deleteConfirm(eventItem?.mainshiftId, eventItem?.id, deleteType);
        } else if (type === "assign") {
          const dataForAssign = {
            date: formattedDate,
            shift: eventItem.title,
            ...eventItem,
          };
          this.setState((prevState) => ({
            showAssignStaffUI: true,
            assignStaffEventDetails: dataForAssign,
          }));
        } else if (type === "proxy") {
          this.setState({ shiftTaskData: eventItem?.item });
          this.setState({ openShiftCompletion: true });
        }
      } else {
        ShowInfoSwal("Your user Role does not have access to this section.");
      }
    };
    const filterAssignedCareteam = eventItem?.assignedCareTeam?.filter(
      (cItem) => cItem?.shiftApprovalstatus !== false
    );
    return (
      <div className={`${cx.personDetail_main}`}>
        <div
          className="d-flex justify-content-between"
          style={{ minWidth: "110px" }}
        >
          {isShiftDatepassed || eventItem?.assignedCareTeam?.length < 1 ? (
            <div className="dropdown">
              <AiOutlineCloseCircle
                style={{ fontSize: "25px", cursor: "pointer" }}
                data-bs-toggle="dropdown"
                aria-expanded="false"
              />
              <ul className="dropdown-menu">
                <li>
                  <a
                    className="dropdown-item"
                    style={{ cursor: "pointer" }}
                    onClick={() => actionClickHandler("delete", "single")}
                  >
                    Delete this shift
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    style={{ cursor: "pointer" }}
                    onClick={() => actionClickHandler("delete", "recurring")}
                  >
                    Delete all associated recurring shifts
                  </a>
                </li>
              </ul>
            </div>
          ) : (
            <span>&nbsp;</span>
          )}
          {isShiftDatepassed ? (
            <AiOutlineUsergroupAdd
              style={{ fontSize: "25px", cursor: "pointer" }}
              onClick={() => actionClickHandler("assign")}
            />
          ) : (
            <span>&nbsp;</span>
          )}
          {!isShowProxyBtn && (
            <img
              src={proxycompleteIcon}
              alt="proxycompleteIcon"
              style={{ weiht: "25px", width: "25px", cursor: "pointer" }}
              onClick={() => actionClickHandler("proxy")}
            />
          )}
        </div>
        {filterAssignedCareteam?.map((item, index) => {
          // console.log(item, "iiiiiiiiiiiiii");
          const grpClnts =
            item.zone || item.all
              ? item.client.map((cItem) => cItem.first_Name)?.join(", ")
              : "";
          const teamData = item.careteam;
          const imageIcon =
            teamData?.image && teamData?.image !== ""
              ? teamData?.image
              : chatUserImg;
          const fullZoneName = this.state.groupWithColorData?.find(
            (elem) => elem.zone === item?.zone
          )?.groupName;
          const zoneName = item.zone
            ? `${fullZoneName} ${grpClnts ? "(" : ""} ${grpClnts ?? ""} ${
                grpClnts ? ")" : ""
              }`
            : `${getFullName(item?.client?.[0])} - Temp`;
          return (
            <div
              key={index}
              className={`${cx.personDetail_box} mt-2 align-items-start`}
            >
              <div className={`${cx.personImg}`}>
                <img
                  src={imageIcon}
                  className={
                    imageIcon.includes("chatUser") ? `forImagecareteam` : ""
                  }
                  alt="img"
                />
              </div>
              <div className={`${cx.personDetails}`}>
                <p>{getFullName(teamData)}</p>
                {/* <p>{teamData.first_Name} {teamData.last_Name}</p> */}
                <p>Job Title - {teamData.jobTitle ?? ""}</p>
                {/* <p>
                  Shift Start -{" "}
                  {item.startTime
                    ? item.startTime
                    : convertToTimeZone(eventItem.start)}
                </p>
                <p>
                  Shift End -{" "}
                  {item.endTime
                    ? item.endTime
                    : convertToTimeZone(eventItem.end)}
                </p> */}
                <p>
                  Group - {item.all ? `All Clients (${grpClnts})` : zoneName}
                </p>
                <span></span>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  eventItemTemplateResolver = (
    schedulerData,
    event,
    bgColor,
    isStart,
    isEnd,
    mustAddCssClass,
    mustBeHeight,
    agendaMaxEventWidth
  ) => {
    const isOpenShift = event?.recurringShiftType === "open";
    let divStyle = {
      border: `${isOpenShift ? "2px solid purple" : "2px solid #F2C94C"}`,
      borderRadius: "5px",
    };
    // let dataForAssign = {
    //   date: event.start?.split(" ")[0],
    //   shift: event.title,
    // };
    const filterAssignedCareteam = event?.assignedCareTeam?.filter(
      (cItem) => cItem?.shiftApprovalstatus !== false
    );
    return (
      <div key={event.id} style={divStyle}>
        <div
          className={cx.resourceInEvent}
          style={{
            backgroundColor: isOpenShift ? "purple" : "#F2C94C",
          }}
        >
          <p>
            {event.title}
            {/* <span><FaRegSun onClick={() => {
            this.setState((prevState) => ({
              showAssignStaffUI: true,
              assignStaffEventDetails: dataForAssign
            }));
          }} /></span> */}
          </p>
          <p>{event.shiftTime}</p>
          <p>Break ({event?.shiftBreak ?? 0}mins)</p>
        </div>
        <div className={cx.eventDiv}>
          {filterAssignedCareteam?.map((item, index) => {
            // let teamName = item.first_Name + ' ' + item.last_Name;
            const zoneName =
              item.zone ?? `${getFullName(item?.client?.[0])} - Temp`;
            const findGroupColor = this.state.groupWithColorData
              ?.filter((cItem) => cItem.status)
              ?.find(
                (elem) => elem.zone === item?.zone || elem.zone === zoneName
              )?.groupColor;
            const groupColor = item?.all ? "#2D9CDB" : findGroupColor;
            return (
              <span key={index} style={{ background: groupColor ?? "red" }}>
                {item.careteam?.first_Name}
              </span>
            );
          })}
        </div>
      </div>
    );
  };

  slotItemTemplateResolver(
    schedulerData,
    slot,
    slotClickedFunc,
    width,
    clsName
  ) {
    return (
      <div className="text-center slotStyle">
        <p>{slot.slotName}</p>
      </div>
    );
  }

  prevClick = (schedulerData) => {
    schedulerData.prev();
    schedulerData.setEvents(this.state?.EventsArr);
    this.setState({
      viewModel: schedulerData,
    });
    this.getShiftsandtaskNew();
  };

  nextClick = (schedulerData) => {
    schedulerData.next();
    schedulerData.setEvents(this.state?.EventsArr);
    this.setState({
      viewModel: schedulerData,
    });
    this.getShiftsandtaskNew();
  };

  onViewChange = (schedulerData, view) => {
    schedulerData.setViewType(
      view.viewType,
      view.showAgenda,
      view.isEventPerspective
    );
    schedulerData.setEvents(this.state.EventsArr);
    this.setState({
      viewModel: schedulerData,
    });
    this.getShiftsandtaskNew();
  };

  onSelectDate = (schedulerData, date) => {
    schedulerData.setDate(date);
    schedulerData.setEvents(this.state.EventsArr);
    this.setState({
      viewModel: schedulerData,
    });
    this.getShiftsandtaskNew();
  };

  eventClicked = (schedulerData, event) => {
    // schedulerData.setEvents(this.state.EventsArr);
    // this.setState({
    //   viewModel: schedulerData,
    // });
  };

  newEvent = (schedulerData, slotId, slotName, start, end, type, item) => {
    if (this.state.SchedulerAccess === "full") {
      this.setState({
        createShiftDate: start?.split(" ")[0],
        showCreateShift: !this.state.showCreateShift,
      });
    } else {
      ShowInfoSwal("Your user Role does not have access to this section.");
    }
  };

  updateEventStart = (schedulerData, event, newStart) => {
    schedulerData.updateEventStart(event, newStart);
    this.setState({
      viewModel: schedulerData,
    });
  };

  updateEventEnd = (schedulerData, event, newEnd) => {
    schedulerData.updateEventEnd(event, newEnd);
    this.setState({
      viewModel: schedulerData,
    });
  };

  onScrollRight = (schedulerData, schedulerContent, maxScrollLeft) => {
    if (schedulerData.ViewTypes === ViewTypes.Day) {
      schedulerData.next();
      schedulerData.setEvents(this.state.EventsArr);
      this.setState({
        viewModel: schedulerData,
      });
      schedulerContent.scrollLeft = maxScrollLeft - 10;
    }
  };

  onScrollLeft = (schedulerData, schedulerContent, maxScrollLeft) => {
    if (schedulerData?.ViewTypes === ViewTypes.Day) {
      schedulerData.prev();
      schedulerData.setEvents(this.state?.EventsArr);
      this.setState({
        viewModel: schedulerData,
      });
      schedulerContent.scrollLeft = 10;
    }
  };

  toggleExpandFunc = (schedulerData, slotId) => {
    schedulerData.toggleExpandStatus(slotId);
    this.setState({ viewModel: schedulerData });
  };
}

// export default WithDragDropContext(Basic);
export default DragDropContext(HTML5Backend)(RotaScheduler);
